<div>
  <file-upload
    [formControl]="control"
    [animation]="animation"
    [accept]="accept"
    [multiple]="multiple">
    <ng-template
      let-isFileDragDropAvailable="isFileDragDropAvailable"
      #placeholder>
      <file-upload-drop-zone>
        <ng-container
          *ngIf="isFileDragDropAvailable; else isNotDragDropAvailable">
          <span *ngIf="placeholderText; else defaultText">
            {{ placeholderText }}
          </span>
          <ng-template #defaultText>
            <span> <b> Arrastra y suelta </b> tu archivo o haz clic aquí </span>
          </ng-template>
        </ng-container>
        <ng-template #isNotDragDropAvailable>
          {{ dragNDropUnavailablePlaceholderText }}
        </ng-template>
      </file-upload-drop-zone>
    </ng-template>

    <ng-template let-i="index" let-file="file" let-control="control" #item>
      <file-upload-list-item [index]="i" [file]="file" [control]="control"
        >Eliminar</file-upload-list-item
      >
    </ng-template>
  </file-upload>
</div>
